import { defineArticleAssets } from "@th-m/blogs/mdx";

export default defineArticleAssets({
});
